import { render, staticRenderFns } from "./TypeALaCarte.vue?vue&type=template&id=16294606&scoped=true&"
import script from "./TypeALaCarte.vue?vue&type=script&lang=js&"
export * from "./TypeALaCarte.vue?vue&type=script&lang=js&"
import style0 from "./TypeALaCarte.vue?vue&type=style&index=0&id=16294606&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16294606",
  null
  
)

export default component.exports